
function serializeTokens(tokens) {
    const stack     = [];
    const content   = [];
    let pos         = 0;

    while (pos < tokens.length) {
        const token = tokens[pos++];

        if (token.type.endsWith("_open")) {
            stack.push({ token, children: [] });

        } else if (token.type.endsWith("_close")) {
            const group = stack.pop();

            if (stack.length) {
                stack.at(-1).children.push(group);

            } else {
                content.push(group);
            }

        } else {
            if (stack.length) {
                stack.at(-1).children.push({
                    token,
                    children: token.children
                        ? serializeTokens(token.children)
                        : [],
                });

            } else {
                content.push({
                    token,
                    children: token.children
                        ? serializeTokens(token.children)
                        : [],
                });
            }
        }
    }

    return content;
}

export function transformMarkdown(tokens) {

    function renderChildren(children) {
        return children.flatMap(renderToken).filter((obj) => obj);
    }

    function renderToken({ token, children }) {
        if (token.type === "text")
            return token.content;

        if (token.type === "softbreak")
            return "\n";

        if (token.type === "inline")
            return renderChildren(children);

        if (token.type === "strong_open")
            return {
                type    : "bold",
                content : renderChildren(children),
            };

        if (token.type === "em_open")
            return {
                type    : "italic",
                content : renderChildren(children),
            };

        if (token.type === "underline_open")
            return {
                type    : "underline",
                content : renderChildren(children),
            };

        if (token.type === "s_open")
            return {
                type    : "strikethrough",
                content : renderChildren(children),
            };

        if (token.type === "link_open")
            return {
                type    : "link",
                content : renderChildren(children),
                url     : token.attrs.find(([ name ]) => name === "href")[1],
            };

        if (token.type === "heading_open")
            return {
                type    : token.tag === "h1" ? "title" : "subtitle",
                content : renderChildren(children),
            };

        if (token.type === "paragraph_open")
            return {
                type    : "text",
                content : renderChildren(children),
            };

        if (token.type === "blockquote_open")
            return {
                type    : "blockquote",
                content : renderChildren(children),
            };

        if (token.type === "bullet_list_open" || token.type === "ordered_list_open")
            return {
                type    : "list",
                items   : children.map((li) => li.children.map(renderToken)),
            };

        if (token.type === "fence") {
            if (token.tag == "code") {
                return {
                    type    : "code_block",
                    lang    : token.info,
                    content : token.content,
                };
            }
        }

        if (token.type === "code_inline")
            return {
                type    : "code_inline",
                content : token.content,
            };

        if (token.type === "emoji")
            return {
                type    : "emoji",
                name    : token.attrs.name,
                url     : `https://cdn.discordapp.com/emojis/${token.attrs.id}`,
            };

        if (token.type === "unicode_emoji")
            return {
                type    : "unicode_emoji",
                content : token.content,
            };

        if (token.type === "hr")
            return "";

        if (token.type === "mention")
            return {
                type    : "mention",
                subType : token.attrs.type,
                id      : token.attrs.id || null,
            };

        if (token.type === "hardbreak")
            return {
                type: "hardbreak",
            };

        console.warn(token);

        return "**ERREUR PARSEUR**";
    }

    return serializeTokens(tokens).map(renderToken);
}
